// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Hidden-module--hidden--3U-AW"};